"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
const NotificationContent = (0, react_1.memo)(({ name = '', description = '', identifier, onSelect, className, important, }) => {
    const handleSelect = () => {
        !important && onSelect && onSelect(identifier);
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { onClick: handleSelect, className: className, "$important": important, "aria-label": "select", "data-e2e": 'Container', children: [(0, jsx_runtime_1.jsx)(StyledName, { "data-e2e": 'StyledName', children: name }), (0, jsx_runtime_1.jsx)(StyledDescription, { "data-e2e": 'StyledDescription', children: description })] }));
});
const Container = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  cursor: ${({ $important }) => ($important ? 'default' : 'pointer')};
  width: 75%;
  height: 88px;

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    height: 64px;
  `)};
`;
const StyledName = styled_components_1.default.span `
  color: ${({ theme }) => theme.designSystem.whiteSecondary};
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
`;
const StyledDescription = styled_components_1.default.span `
  color: ${({ theme }) => theme.designSystem.textSecondary};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
exports.default = NotificationContent;
